import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTruck, faClock, faDollarSign } from '@fortawesome/free-solid-svg-icons';

const MiniDashboard = ({ shipments, calculateAging }) => {
  const calculateAverageAging = () => {
    const totalAging = shipments.reduce((acc, shipment) => acc + calculateAging(shipment.PedimentoFecha), 0);
    return (shipments.length > 0) ? (totalAging / shipments.length).toFixed(2) : 0;
  };

  const calculateTotalFinanciado = () => {
    const totalFinanciado = shipments.reduce((acc, shipment) => {
      const financiado = parseFloat(shipment.TotalFinanciado);
      return Number.isFinite(financiado) ? acc + financiado : acc;
    }, 0);
  
    // Format the number with thousands separator and two decimal places
    return new Intl.NumberFormat('en-US', { 
      style: 'decimal',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    }).format(totalFinanciado);
  };

  const traficosCount = shipments.length;
  const averageAging = calculateAverageAging();
  const totalFinanciado = calculateTotalFinanciado();

  return (
    <div className="bg-white shadow rounded-lg p-3 w-full">
      <div className="grid grid-cols-3 divide-x divide-gray-200 text-center">
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faTruck} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Traficos</p>
          <p className="text-lg font-semibold text-gray-800">{traficosCount}</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faClock} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Average Aging</p>
          <p className="text-lg font-semibold text-gray-800">{averageAging} days</p>
        </div>
        <div className="flex flex-col items-center justify-center py-1">
          <FontAwesomeIcon icon={faDollarSign} className="text-blue-600 text-2xl mb-1" />
          <p className="text-sm text-gray-600">Total Financed</p>
          <p className="text-lg font-semibold text-gray-800">$ {totalFinanciado}</p>
        </div>
        {/* More data elements can be added here in a similar pattern */}
      </div>
    </div>
  );
};

export default MiniDashboard;
